<template>
  <div>
    <MainText class="title" text="About" />
    <p>
      Welcome! I am a fifth-year PhD student in the
      <Link
        path="https://cse.wustl.edu/index.html"
        text="Computer Science Department"
      />
      at
      <Link
        path="https://wustl.edu/"
        text="Washington University in St. Louis"
      />
      (WashU), under the guidance of Prof.
      <Link path="https://rochguerin.github.io/" text="Roch Guerin" />. I
      earned my Bachelor degree in Computer Science from WashU in 2020.
    </p>
    <p>
      My research focuses on computer networks, with particular interests
      in network optimization, edge computing, and leveraging
      machine learning techniques to enhance the efficiency and
      flexibility of network systems.
    </p>
    <p>
      For more details about about my background and a complete list of my publications,
      please visit the <router-link to="/background">Background</router-link> and
      <router-link to="/publications">Publications</router-link> sections.
    </p>
  </div>
</template>

<script>
import MainText from "../components/MainText";
import Link from "../components/Link";

export default {
  name: "Home",
  components: {
    MainText,
    Link,
  },
};
</script>

<style scoped>
div {
  position: absolute;
  top: 90px;
  left: 360px;
  padding-left: 60px;
  padding-right: 90px;
}
p {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #212325;
  font-size: 20px;
  line-height: 150%;
  text-align: justify;
}
a {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #66ccff;
  font-size: 20px;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
@media (max-width: 1000px) {
  div {
    top: 120px;
    left: 0;
    padding-right: 60px;
  }
  p {
    font-size: 18px;
  }
  p.title {
    font-size: 30px;
    margin-bottom: 20px;
  }
  a {
    font-size: 18px;
  }
}
@media (max-width: 600px) {
  div {
    padding-left: 30px;
    padding-right: 30px;
  }
  p {
    font-size: 15px;
  }
  p.title {
    font-size: 25px;
    margin-bottom: 15px;
  }
  a {
    font-size: 15px;
  }
}
</style>